const messages = {
    "audit_result_paired_hint": [
        "* V kontrolách auditu jsou zahrnuté pouze spárované produkty.",
        "* V kontrolách auditu sú zahrnuté iba spárované produkty.",
    ],

    "single_shop": [
        "Produkt je sám v produktové kartě",
        "Produkt je sám v produktovej karte",
    ],
    "single_shop_info": [
        "Jestli víte o několika konkurentech s podobnou nabídkou, existuje pravděpodobnost, že je produkt spárovaný do nesprávné karty na Heurece. Doporučujeme zkontrolovat správnost elementů PRODUCTNAME a CATEGORYTEXT podle požadavků Heureky a nebo kontaktovat zákaznickou podporu Heureky. Nemusí se však jednat o problém v případě, že nabízíte specifický sortiment.",
        "Ak viete o niekoľkých konkurentoch s podobnou ponukou, existuje pravdepodobnosť, že je produkt spárovaný do nesprávnej karty na Heureke. Odporúčame skontrolovať správnosť elementov PRODUCTNAME a CATEGORYTEXT podľa požiadaviek Heureky, alebo kontaktovať zákaznícku podporu Heureky. Nemusí sa však jednať o problém v prípade, že ponúkate špecifický sortiment.",
    ],
    "no_shipping_price": [
        "Nabídky nemají nastavené ceny za dopravu",
        "Ponuky nemajú nastavené ceny za dopravu",
    ],
    "no_shipping_price_info": [
        "Bez této informace se vaše produkty nedostanou na biddované pozice. Cena za dopravu je taktéž důležitý rozhodovací prvek pro zákazníka.",
        "Bez tejto informácie sa vaše produkty nedostanú na biddované pozície. Cena za dopravu je taktiež dôležitý rozhodovací prvok pre zákazníka.",
    ],
    "not_paired": [
        "Nespárované produkty",
        "Nespárované produkty",
    ],
    "not_paired_info": [
        "Produkty jsou nespárované, protože jim chybí a nebo nemají správně vyplněné parametry podle požadavků Heureky. O tom, jak si s párováním poradit, se dočtete na <a href=\"https://blog.heureka.cz/2021/03/04/jak-na-parovani-na-heurece-povinne-parametry/\" target=\"_blank\">jejich blogu</a>.",
        "Produkty sú nespárované, pretože im chýba alebo nemajú správne vyplnené parametre podľa požiadaviek Heureky. O tom, ako si s párovaním poradiť, sa dočítate na <a href=\"https://blog.heureka.cz/2021/03/04/jak-na-parovani-na-heurece-povinne-parametry/\" target=\"_blank\">ich blogu</a>.",
    ],
    "zero_price": [
        "Produkty s nulovou nebo zápornou cenou",
        "Produkty s nulovou alebo zápornou cenou",
    ],
    "zero_price_info": [
        "Nulové či záporné ceny ve feedu způsobí, že se produkty nedostanou do inzerce na srovnávači. Zjistěte, o které produkty jde a následně jejich cenu upravte v elementu PRICE_VAT.",
        "Nulové či záporné ceny vo feede spôsobia, že sa produkty nedostanú do inzercie na porovnávači tovaru. Zistite, o ktoré produkty ide a následne ich cenu upravte v elemente PRICE_VAT.",
    ],
    "competitors_with_same_price_with_free_shipping": [
        "Konkurent se stejnou cenou doručí objednávku zdarma",
        "Konkurent s rovnakou cenou dopraví objednávku zdarma",
    ],
    "competitors_with_same_price_with_free_shipping_info": [
        "Jiný e-shop nabízí produkt za stejnou cenu jako vy, přičemž má navíc dopravu zdarma. Ve výsledku je levnější a zákazník ho pravděpodobně upřednostní. Zkontrolujte, o které produkty jde a zda se dá hýbat s jejich cenou, popřípadě s cenou dopravy.",
        "Iný e-shop ponúka produkt za rovnakú cenu ako vy, pričom má naviac dopravu zdarma. Vo výsledku je lacnejší a zákazník ho pravdepodobne uprednostní. Skontrolujte, o ktoré produkty ide a či sa dá hýbať s ich cenou, prípadne cenou dopravy.",
    ],
    "competitors_with_same_price_with_gift": [
        "Konkurent se stejnou cenou přikládá i dárek k nákupu",
        "Konkurent s rovnakou cenou prikladá aj darček k nákupu",
    ],
    "competitors_with_same_price_with_gift_info": [
        "Jiný e-shop na kartě nabízí produkt za stejnou cenu jako vy a ještě k nákupu přibalí i dárek. Má díky tomu nad vámi převahu. Zkontrolujte, o které produkty jde a zda lze upravit jejich cena, popřípadě přibalte dárek k nákupu i vy.",
        "Iný e-shop na karte ponúka produkt za rovnakú cenu ako vy, pričom pribalí k nákupu aj darček. Má vďaka tomu nad vami prevahu. Skontrolujte, o ktoré produkty ide a či je možné upraviť ich cenu, prípadne pribaľte darček k nákupu aj vy.",
    ],
    "more_than_10_position": [
        "Nabídky na 11. a nižší pozici",
        "Ponuky na 11. a nižšej pozícii",
    ],
    "more_than_10_position_info": [
        "Produktová karta Heureky vypisuje jen 10 nabídek v seznamu podle ceny, další si zákazník musí manuálně zobrazit. Svou šanci na proklik určitě zvýšíte, když se podaří produktům dostat mezi prvních 10 nabídek.",
        "Produktová karta Heureky vypisuje iba 10 ponúk v zozname podľa ceny, ďalšie si musí zákazník manuálne zobraziť. Svoju šancu na preklik určite zvýšite, ak sa podarí produktom dostať medzi prvých 10 ponúk.",
    ],
    "is_most_expansive": [
        "Nabídky jsou na kartě nejdražší",
        "Ponuky sú na karte najdrahšie",
    ],
    "is_most_expansive_info": [
        "Mezi všemi nabídkami je ta vaše nejdražší. Koukněte, který sortiment máte na Heurece nejdražší a jestli není možné jej zlevnit.",
        "Spomedzi všetkých ponúk je tá vaša najdrahšia. Omrknite, ktorý sortiment máte na Heureke najdrahší a či ho nie je možné zlacniť.",
    ],
    "similar_but_better_availability": [
        "Nabídky s dlouhou dobou dodání",
        "Ponuky s dlhou dobou dodania",
    ],
    "similar_but_better_availability_info": [
        "Minimálně 5 konkurenčních nabídek s nižší cenou má lepší dostupnost než vy. Pokud nelze snížit cena, prověřte, zda můžete zboží dodat dříve.",
        "Minimálne 5 konkurenčných ponúk s nižšou cenou má lepšiu dostupnosť ako vy. Ak nie je možné znížiť cenu, preverte, či môžete dodať tovar skôr.",
    ],
    "p130_of_cheapest": [
        "Min. o 30 % dražší oproti nejlevnějšímu konkurentovi",
        "Min. o 30 % drahší oproti najlacnejšiemu konkurentovi",
    ],
    "p130_of_cheapest_info": [
        "Tak výrazný cenový rozdíl může při velkém počtu konkurentů způsobit, že vaše nabídka zapadne na nejnižší příčkách produktové karty. Pokud není možné manipulovat s cenou, ujistěte se, že dokážete dodat zboží ihned, za nízkou cenu a nebo zdarma. Případně popřemýšlejte o přibalení dárečku k objednávce.",
        "Tak výrazný cenový rozdiel môže pri veľkom počte konkurentov spôsobiť, že vaša ponuka zapadne na najnižších priečkach produktovej karty. Ak nie je možné manipulovať s cenou, uistite sa, že dokážete dodať tovar ihneď, za nízku cenu alebo zdarma. Prípadne pouvažujte o pribalení darčeku k objednávke.",
    ],
    "competitors_below_purchase_price": [
        "Konkurenti prodávají produkt pod mou nákupkou",
        "Konkurenti predávajú produkt pod mojou nákupkou",
    ],
    "competitors_below_purchase_price_info": [
        "Vaši soupeři na produktové kartě prodávají sortiment levněji, než je hodnota vaší nákupní ceny. Prověřte si, zda nejsou limity dané dodavatelem, popřípadě se zamyslete, jestli nemůžete svou nabídku ještě zlevnit.",
        "Vaši súperi na produktovej karte predávajú sortiment lacnejšie, než je hodnota vašej nákupnej ceny. Preverte, či nie sú limity dané dodávateľom, prípadne sa zamyslite, či by nebolo možné svoju ponuku zlacniť.",
    ],
    "few_shops": [
        "Méně než 5 nabídek v kartě",
        "Menej ako 5 ponúk v karte",
    ],
    "few_shops_info": [
        "V produktové kartě Heureky je méně než 5 nabídek. Využijte příležitost a pokuste se odlišit rychlostí či nízkou cenou dopravy, popřípadě přibalte k objednávce dárek. Málo nabídek v kartě však může signalizovat i to, že je produkt špatně spárovaný.",
        "V produktovej karte Heuréky je menej ako 5 ponúk. Využite príležitosť a pokúste sa odlíšiť rýchlosťou či nízkou cenou dopravy, poprípade pribaľte k objednávke darček. Málo ponúk v karte však môže signalizovať aj to, že je produkt zle spárovaný.",
    ],
    "my_price_below_purchase_price": [
        "Produkty prodávané pod nákupní cenou",
        "Produkty predávané pod nákupnou cenou",
    ],
    "my_price_below_purchase_price_info": [
        "Na prodeji těchto produktů jste ztrátoví, a zároveň můžete přijít do sporu s dodavatelem zboží a jeho doporučenými prodejními cenami.",
        "Na predaji týchto produktov ste stratoví a zároveň môžete prísť do sporu s dodávateľom tovaru a jeho odporúčanými predajnými cenami.",
    ],

    "not_in_bidding": [
        "Produkty mimo bidding",
        "Produkty mimo bidding",
    ],
    "not_in_bidding_info": [
        "V momentě kontroly nebyly tyto produkty v biddingu. Problém může nastat v případě, že se vaše nabídka nezobrazuje mezi prvními a nejde vidět ve srovnání podle ceny.",
        "V momente kontroly neboli tieto produkty v biddingu. Problém môže nastať v prípade, že sa vaša ponuka nezobrazuje medzi prvými a nie je vidieť v porovnaní podľa ceny.",
    ],
    "most_expensive_in_bidding": [
        "V biddingu je moje nabídka nejdražší",
        "V biddingu je moja ponuka najdrahšia",
    ],
    "most_expensive_in_bidding_info": [
        "V seznamu biddovaných nabídek je vaše nabídka nejdražší. Snížením ceny by mohla získat lepší pozici a zvýšila by se její konkurenceschopnost. Když to spojíte s nižší cenou za dopravu a dárkem k objednávce, budete mít nad konkurenty rozhodně navrch.",
        "V zozname biddovaných ponúk je vaša ponuka najdrahšia. Znížením ceny by mohla získať lepšiu pozíciu a zvýšila by sa jej konkurencieschopnosť. Ak to spojíte s nižšou cenou za dopravu a darčekom k objednávke, budete mať nad konkurentmi rozhodne navrch.",
    ],
    "cheapest_in_bidding": [
        "V biddingu je moje nabídka nejlevnější",
        "V biddingu je moja ponuka najlacnejšia",
    ],
    "cheapest_in_bidding_info": [
        "Cena těchto produktů v biddingu je mezi všemi biddovanými nabídkami nejlevnější. Můžete uvažovat o mírném zvýšení ceny a získat tak z každé objednávky více.",
        "Cena týchto produktov v biddingu je spomedzi všetkých biddovaných ponúk najlacnejšia. Môžete uvažovať o miernom zvýšení ceny a získať tak z každej objednávky viac.",
    ],
    "first_and_too_cheap": [
        "Jsem nejlevnější a druhá nabídka je o více než 10 % dražší",
        "Som najlacnejší a druhá ponuka je o viac než 10 % drahšia",
    ],
    "first_and_too_cheap_info": [
        "Cenový rozdíl mezi vaší a druhou konkurenční nabídkou je 10 % a více. Můžete zvážit zvýšení ceny produktů, čím by mohl vzrůst i zisk.",
        "Cenový rozdiel medzi vašou a druhou konkurenčnou ponukou je 10 % a viac. Môžete zvážiť zvýšenie ceny produktov, čím by mohol vzrásť aj zisk.",
    ],
    "cheapest": [
        "Jsem nejlevnější na kartě",
        "Som najlacnejší na karte",
    ],
    "cheapest_info": [
        "Vaše nabídka je na produktové kartě, v seznamu podle ceny na prvním místě. Zkontrolujte, o které produkty se jedná a následně můžete uvažovat o mírném navýšení ceny tak, abyste si udrželi pozici a zároveň měli vyšší zisk.",
        "Vaša ponuka je na produktovej karte, v zozname podľa ceny na prvom mieste. Skontrolujte, o ktoré produkty ide a následne môžete uvažovať o miernom navýšení ceny tak, aby ste si udržali pozíciu a zároveň mali vyšší zisk.",
    ],

    "products": [
        "Produkty",
        "Produkty",
    ],
    "group_ok": [
        "V pořádku",
        "V poriadku",
    ],
    "group_ok_info": [
        "Právě si prohlížíte {group_ok} produktů, které jsou konkurenceschopné a bez inzertních problémů. Níže na stránce objevíte graf s rozložením tohoto sortimentu podle ceny, a pod ním výpis jednotlivých produktů. Je možné je vyexportovat, zkontrolovat na Heurece a nebo ve svém e-shopu.",
        "Práve si prehliadate {group_ok} produktov, ktoré sú konkurencieschopné a bez inzertných problémov. Na stránke nižšie objavíte graf s rozložením tohto sortimentu podľa ceny, a pod ním výpis jednotlivých produktov. Je možné ich vyexportovať, skontrolovať na Heureke alebo vo svojom e-shope.",
    ],
    "group_problems": [
        "S problémem",
        "S problémom",
    ],
    "group_problems_info": [
        "Při kontrole jsme detekovali {group_problems} problémových produktů, které kvůli různým nedostatkům nevyužívají svůj potenciál na 100 %. Níže naleznete graf rozložení sortimentu podle ceny a díky výpisu jednotlivých problémů zjistíte, na které produkty se zaměřit a popřípadě, co by se dalo zlepšit. Nechybí možnost exportu, kontroly na Heurece či v e-shopu.",
        "Pri kontrole sme detekovali {group_problems} problémových produktov, ktoré kvôli rôznym nedostatkom nevyužívajú svoj potenciál na 100 %. Nižšie nájdete graf rozloženia sortimentu podľa ceny a vďaka výpisu jednotlivých problémov zistíte, na ktoré produkty sa zamerať, a čo by sa dalo prípadne zlepšiť. Nechýba možnosť exportu, kontroly na Heureke či v e-shope.",
    ],
    "group_warnings": [
        "S upozorněním",
        "S upozornením",
    ],
    "group_warnings_info": [
        "U {group_warnings} produktů jsme našli nesrovnalosti, které by stály za vaši pozornost. Projděte si graf, rozepsaná upozornění k jednotlivým produktům a zvyšte svůj výkon inzerce na Heurece. V případě potřeby si sortiment můžete vyexportovat, zkontrolovat na srovnávači či ve svém e-shopu.",
        "U {group_warnings} produktov sme našli nezrovnalosti, ktoré by stáli za vašu pozornosť. Prezrite si graf, rozpísané upozornenia k jednotlivým produktom a zvýšte výkon svojej inzercie na Heureke. V prípade potreby si sortiment môžete vyexportovať, skontrolovať na porovnávači alebo vo svojom e-shope.",
    ],
    "group_recommendations": [
        "S doporučením",
        "S odporúčaním",
    ],
    "group_recommendations_info": [
        "Jen krůček od absolutní konkurenceschopnosti na Heurece je celkem {group_recommendations}  produktů. Doporučení se skládají z maličkostí, kterými dáte jasně najevo, kdo má v inzerci převahu. Na stránce najdete graf rozložení sortimentu podle ceny, výpis jednotlivých doporučení a konkrétní produkty, o kterých se bavíme. Nabídky je možné vyexportovat, zkontrolovat na Heurece a nebo ve svém e-shopu.",
        "Iba krôčik od absolútnej konkurencieschopnosti na Heureke je celkovo {group_recommendations}  produktov. Odporúčania pozostávajú z maličkostí, ktorými dáte jasne najavo, kto má v inzercii navrch. Na stránke nájdete graf rozloženia sortimentu podľa ceny, výpis jednotlivých odporúčaní a konkrétne produkty, o ktoré ide. Ponuky je možné vyexportovať, skontrolovať na Heureke alebo vo svojom e-shope.",
    ],
    "audit_result_info": [
        "Při kontrole sortimentu jsme prověřili celkově <strong>{total} produktů</strong>, z kterých je na Heurece <strong>{paired} spárovaných</strong> ({paired_ratio}). Ty jsou nejčastěji na {most_position}. pozici produktové karty, přičemž průměrně soutěží s {avg_offers} konkurenčními nabídkami. Sortiment jsme rozdělili do čtyř kategorií podle toho, jak v auditu obstál.",
        "Pri kontrole sortimentu sme preverili celkovo <strong>{total} produktov</strong>, z ktorých je na Heureke <strong>{paired} spárovaných</strong> ({paired_ratio}). Tie sú najčastejšie na {most_position}. pozícii produktovej karty, pričom priemerne súťažia s {avg_offers} konkurenčnými ponukami. Sortiment sme rozdelili do štyroch kategórií podľa toho, ako v audite obstál.",
    ],

    "pricing_result_footer": [
        "Chcete vyřešit problémy a pomocí upozornění a doporučení vyšperkovat svůj sortiment k dokonalosti? Nabízíme možnost <strong>automatické cenotvorby</strong> pomocí šikovného <strong>nástroje Pricing Fox</strong>. Vyzkoušejte si ho na <strong>30 dní zdarma</strong>. Buďte efektivní, přeceňujte automaticky.",
        "Chcete vyriešiť problémy a pomocou upozornení a odporúčaní vyšperkovať svoj sortiment k dokonalosti? Ponúkame možnosť <strong>automatickej cenotvorby</strong> pomocou šikovného <strong>nástroja Pricing Fox</strong>. Vyskúšajte si ho na <strong>30 dní zdarma</strong>. Buďte efektívni, preceňujte automaticky.",
    ],
    "pf_30_days_free": [
        "30 dní zdarma",
        "30 dní zadarmo",
    ],
    "n_problems": [
        "problémů",
        "problémov",
    ],
    "n_warnings": [
        "upozornění",
        "upozornení",
    ],
    "n_recommendations": [
        "doporučení",
        "odporúčaní",
    ],
    "pf_cta_banner_line1": [
        "Ty vyřeší <strong>Pricing Fox</strong>!",
        "Tie vyrieši <strong>Pricing Fox</strong>!",
    ],
    "pf_cta_banner_line2": [
        "Nyní na 30 dní zdarma",
        "Nyní na 30 dní zadarmo",
    ],

    "my_products": [
        "Mé produkty",
        "Moje produkty",
    ],
}

module.exports.phrases = {
    locale: ["cs-CZ","sk-SK"],
    messages,
}
